import "leaflet/dist/leaflet.css";
import { Suspense } from "react";
import { Container } from "react-bootstrap";
import { CookiesProvider } from "react-cookie";
import { Navigate, Route, Routes } from "react-router-dom";
import "./assets/fonts/index.css";
import Header from "./components/Header";
import Navigation from "./components/Navigation";
import AdminSite from "./pages/AdminSite";
import ImageCropperSite from "./pages/ImageCropperSite";
import ImageOverviewSite from "./pages/ImageOverviewSite";
import ImportSite from "./pages/ImportSite";
import LoginSite from "./pages/LoginSite";
import MainSite from "./pages/MainSite";
import MapSite from "./pages/MapSite";
import NotFoundSite from "./pages/NotFoundSite";
import SearchOverviewSite from "./pages/SearchOverviewSite";
import SuggestChangesSite from "./pages/SuggestChangesSite";
import SwipeAddEditSite from "./pages/SwipeAddEditSite";
import SwipeCheckOverviewSite from "./pages/SwipeCheckOverviewSite";
import SwipeCheckSite from "./pages/SwipeCheckSite";
import SwipeDetailSite from "./pages/SwipeDetailSite";
import SwipeOverviewSite from "./pages/SwipeOverviewSite";
import TagAddEditSite from "./pages/TagAddEditSite";
import TagDetailSite from "./pages/TagDetailSite";
import TaggroupAddEditSite from "./pages/TaggroupAddEditSite";
import TaggroupDetailSite from "./pages/TaggroupDetailSite";
import TaggroupsOverviewSite from "./pages/TaggroupsOverviewSite";
import TagsOverviewSite from "./pages/TagsOverviewSite";
import useAuth, { AuthenticationProvider } from "./services/hooks/useAuth";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated() ? children : <Navigate to="/login" />;
};

const App = () => {
  return (
    <Suspense fallback="loading">
      <CookiesProvider>
        <AuthenticationProvider>
          <Header />
          <Navigation />
          <div className="content">
            <Container fluid>
              <Routes>
                <Route
                  path="/tags"
                  element={
                    <ProtectedRoute>
                      <TagsOverviewSite />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/tag/add"
                  element={
                    <ProtectedRoute>
                      <TagAddEditSite />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/tag/edit/:tag_id"
                  element={
                    <ProtectedRoute>
                      <TagAddEditSite />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/tag/:tag_id"
                  element={
                    <ProtectedRoute>
                      <TagDetailSite />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/taggroups"
                  element={
                    <ProtectedRoute>
                      <TaggroupsOverviewSite />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/taggroup/add"
                  element={
                    <ProtectedRoute>
                      <TaggroupAddEditSite />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/taggroup/edit/:taggroup_id"
                  element={
                    <ProtectedRoute>
                      <TaggroupAddEditSite />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/taggroup/:taggroup_id"
                  element={
                    <ProtectedRoute>
                      <TaggroupDetailSite />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/swipes"
                  element={
                    <ProtectedRoute>
                      <SwipeOverviewSite />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/swipe/:swipe_id"
                  element={
                    <ProtectedRoute>
                      <SwipeDetailSite />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/swipe/add"
                  element={
                    <ProtectedRoute>
                      <SwipeAddEditSite />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/swipe/edit/:swipe_id"
                  element={
                    <ProtectedRoute>
                      <SwipeAddEditSite />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/swipe/check"
                  element={
                    <ProtectedRoute>
                      <SwipeCheckOverviewSite />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/swipe/check/:swipe_id"
                  element={
                    <ProtectedRoute>
                      <SwipeCheckSite />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/map"
                  element={
                    <ProtectedRoute>
                      <MapSite />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/images"
                  element={
                    <ProtectedRoute>
                      <ImageOverviewSite />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/images/crop"
                  element={
                    <ProtectedRoute>
                      <ImageCropperSite />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/searches"
                  element={
                    <ProtectedRoute>
                      <SearchOverviewSite />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/import"
                  element={
                    <ProtectedRoute>
                      <ImportSite />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <AdminSite />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/suggest-changes"
                  element={
                    <ProtectedRoute>
                      <SuggestChangesSite />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <MainSite />
                    </ProtectedRoute>
                  }
                />
                <Route path="/login" element={<LoginSite />} />
                <Route path="*" element={<NotFoundSite />} />
              </Routes>
            </Container>
          </div>
        </AuthenticationProvider>
      </CookiesProvider>
    </Suspense>
  );
};

export default App;
